<template>
  <div>
    <b-alert v-if="hasAnyUnconfirmedStatus" show variant="info" class="p-4 text-center">
      <p class="mb-0">
        {{ $t('inventories.fillingDataMessage') }}.
      </p>
    </b-alert>

    <b-alert v-if="hasAnyUnconfirmedStatus" show variant="warning" class="p-4">
      <h5 class="mb-3">
        <font-awesome-icon
          icon="exclamation-triangle"
          class="align-middle"
          :class="{ 'mr-2': $dir.ltr, 'ml-2': $dir.rtl }"
        />

        {{ $t('shared.systemMessage') }} :
      </h5>

      <ul class="mb-0">
        <li v-if="!phoneNumberConfirmed">
          <a href="/account/confirm-phone-number" class="inherited-link">
            {{ $t('account.confirmYourPhoneNumber') }}.
          </a>
        </li>

        <li v-if="!emailConfirmed">
          <a href="/account/confirm-email" class="inherited-link">
            {{ $t('account.confirmYourEmail') }}.
          </a>
        </li>

        <li v-if="phoneNumberConfirmed && emailConfirmed && !inventoryDataApproved">
          <a href="/account/profile/basic-info" class="inherited-link">
            {{ $t('inventories.confirmYourBasicData') }}.
          </a>
        </li>
      </ul>
    </b-alert>
  </div>
</template>

<script>
export default {
  name: 'SystemAlerts',
  computed: {
    userStatus () {
      return this.$store.state.$userStatus
    },
    phoneNumberConfirmed () {
      return this.userStatus && this.userStatus.phoneNumberConfirmed
    },
    emailConfirmed () {
      return this.userStatus && this.userStatus.emailConfirmed
    },
    inventoryDataApproved () {
      return this.userStatus && this.userStatus.inventoryDataApproved
    },
    hasAnyUnconfirmedStatus () {
      return this.userStatus &&
        (!this.userStatus.phoneNumberConfirmed ||
        !this.userStatus.emailConfirmed ||
        !this.userStatus.inventoryDataApproved)
    }
  }
}
</script>
